import { FormsActionTypes, FormsEntities } from '@bimser/common';
import { IBaseAction } from '@bimser/core';
import { takeEvery } from 'redux-saga/effects';
import { modelChanged } from './modelChange';

export default function* watchModelChanged() {
	yield takeEvery(FormsActionTypes.MODEL_CHANGE_TRANSACTION, designerModelChanged);
}

export function* designerModelChanged(sagaAction: IBaseAction<FormsEntities.ModelChangeAction>) {
	yield modelChanged(sagaAction);
}
